import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCategory } from '../../context/CategoryContext';
import { FaSpinner } from 'react-icons/fa';
import './ProductCarouselMarcas.css';

import card1 from "../../img/DELL.png";
import card2 from "../../img/HP.png";
import card3 from "../../img/KINGSTON.png";
import card4 from "../../img/LENOVO.png";
import card5 from "../../img/LOGITECH.png";
import card6 from "../../img/MICROSOFT.png";
import card7 from "../../img/SAMSUNG.png";
import card8 from "../../img/TOSHIBA.png";
import card9 from "../../img/WESTERN DIGITAL.png";
import card10 from "../../img/Xiaomi.png";

const brands = [
  { id: 1, name: 'DELL', image: card1 },
  { id: 2, name: 'HPE', image: card2 },
  { id: 3, name: 'KINGSTON', image: card3 },
  { id: 4, name: 'LENOVO', image: card4 },
  { id: 5, name: 'LOGITECH', image: card5 },
  { id: 6, name: 'MICROSOFT', image: card6 },
  { id: 7, name: 'SAMSUNG', image: card7 },
  { id: 8, name: 'TOSHIBA', image: card8 },
  { id: 9, name: 'WESTERN DIGITAL', image: card9 },
  { id: 10, name: 'Xiaomi', image: card10 },
];

const BannerMarcas = () => {
  const navigate = useNavigate();
  const { setBrand, setCategory } = useCategory();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500); // Simulação de carregamento
    return () => clearTimeout(timer);
  }, []);

  const handleBrandClick = (brandName) => {
    setCategory(null);
    setBrand(brandName);
    navigate(`/category/${encodeURIComponent(brandName)}`);
  };

  return (
    <div className="banner-containerMarcas">
      <h3 style={{ textAlign: "center" }}>Marcas mais pesquisadas</h3>

      {isLoading ? (
        <div className="loading-container">
          <FaSpinner className="spinner" size={30} />
      
        </div>
      ) : (
        <div className="row">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="card-bannerMarcas"
              onClick={() => handleBrandClick(brand.name)}
            >
              <img src={brand.image} alt={brand.name} className="category-image" />
              <p>{brand.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BannerMarcas;
